import { NB } from '@cerebral-inc/ui';
import { CustomSpinner } from './styled';

const { Flex } = NB;

export const BasicSpinner = () => {
  return (
    <Flex w="50px" mx="auto" mt="40px" justifyContent="center">
      <CustomSpinner />
    </Flex>
  );
};
